import imageUnete from "/src/assets/images/unete/unete-image.png"

export const uneteToke = {
    title: "Únete a Toke",
    intro: "¿No eres cliente de Banco<br> Popular ni de Qik?",
    description: "<p>Sigue estos pasos para unirte a Toke:</p>",
    image: imageUnete,

    paths: {
        noClient: {
            label: "No soy cliente de Banco Popular ni de Qik",
            steps: [
                {
                    step: 1,
                    title: "Descarga la App Toke",
                    subtitle: "Desde Google Play o App Store."
                },
                {
                    step: 2,
                    title: "Abre tu cuenta 100% digital",
                    subtitle: "Sin papeleos ni filas. Solo con tu cédula y tu celular."
                },
                {
                    step: 3,
                    title: "Activa tu perfil de pagos",
                    subtitle: "Desde que entres a la app, activa los pagos a número de celular y QR."
                },
                {
                    step: 4,
                    title: "Empieza a recibir tus pagos",
                    subtitle: "Y sé de los primeros en vivir esta nueva forma de pagar."
                }
            ]
        },

        client: {
            label: "Soy cliente de Banco Popular o Qik"
        }
    }
};
